package com.routexk.quiz.ui.sections.header

import androidx.compose.runtime.*
import com.routexk.quiz.ui.sections.header.components.HamburgerButton
import com.routexk.quiz.ui.sections.header.components.SideMenu

@Composable
internal fun NavHeaderMobile() {
    var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }

    HamburgerButton(onClick = { menuState = SideMenuState.OPEN })

    if (menuState != SideMenuState.CLOSED) {
        SideMenu(
            menuState = menuState,
            close = { menuState = menuState.close() },
            onAnimationEnd = {
                if (menuState == SideMenuState.CLOSING) {
                    menuState = SideMenuState.CLOSED
                }
            }
        )
    }
}
